import BaseApiRequest from "./BaseApiRequest";
import { FIND_APPLICANT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetLendingProductRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = [];

  url = FIND_APPLICANT_URL;

  constructor(payLoad) {
    super();
    this.url = `${this.url}?inveriteRequestGuid=${payLoad.inveriteRequestGuid}`;
    if (payLoad.relationship) {
      this.url = `${this.url}&relationship=${payLoad.relationship}`;
    }
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
